import React, { Fragment } from 'react';
import Api from '../../api/api';
import DinamicTable from '../common/dinamic-table';
import OverlayLoading from '../common/overlay-loading';

export default class RewardLogs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    componentDidMount = () => {
        this.updateTable();
    }

    updateTable = async () => {
        await this.setState({ loading: true });
        let req = await Api.get('reward-logs', {
            order: 'created desc',
            limit: 100,
        });
        if (!req.error) {
            let rows = req.data;
            console.log(rows)
            let cols = [
                'Operation',
                'Amount',
                'Address',
                'Created'
            ];
            rows = rows.map(row => {
                return [
                    row.operation,
                    (parseFloat(row.amount) / 1e9).toFixed(9),
                    row.address,
                    new Date(row.created).toLocaleString(),
                ]
            });
            this.table.updateTable(cols, rows);
        }
        await this.setState({ loading: false });
    }

    render() {
        return (
            <Fragment>
                <OverlayLoading show={this.state.loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Reward Logs</h5>
                                        </div>
                                    </div>
                                </div>
                                <DinamicTable
                                    size="20"
                                    ref={ref => this.table = ref}
                                    openRow={this.openRow}
                                    deleteRow={this.deleteRow}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
